import { useThree } from '@react-three/fiber'
import { useCallback, useMemo } from 'react'
import { Material, ShaderMaterial } from 'three'
import { MaterialWarmup } from './materials/MaterialWarmup'
import { useEndCardShaderMaterials } from './models/card/endCardMaterials'
import { tunnelShader } from './models/tunnel/TunnelShader'
import { tunnelShaderStele } from './models/tunnel/TunnelShaderStele'
import { useSteleBreakpoint } from '../hooks/useBreakpoint'

export function ShaderWarmup() {
    const size = useThree((state) => state.size)
    const isStele = useSteleBreakpoint()
    const shaderMaterials = useEndCardShaderMaterials()
    const tunnelMaterial = isStele ? tunnelShaderStele : tunnelShader
    const materials = useMemo(() => [
        tunnelMaterial,
        shaderMaterials.voidMaterial,
        shaderMaterials.backgroundMaterials.battery,
        shaderMaterials.backgroundMaterials.coin,
        shaderMaterials.backgroundMaterials.shield,
        shaderMaterials.backgroundMaterials.stars,
        shaderMaterials.frame1Material,
        shaderMaterials.frame2Materials.battery,
        shaderMaterials.frame2Materials.coin,
        shaderMaterials.frame2Materials.shield,
        shaderMaterials.frame2Materials.stars,
        shaderMaterials.streaksMaterials.battery,
        shaderMaterials.streaksMaterials.coin,
        shaderMaterials.streaksMaterials.shield,
        shaderMaterials.streaksMaterials.stars,
    ] as Material[], [shaderMaterials, tunnelMaterial])

    const prepareMaterial = useCallback((material: Material) => {
        if (
            material instanceof ShaderMaterial &&
            material.uniforms.uResolution?.value
        ) {
            material.uniforms.uResolution.value.set(size.width, size.height)
        }
    }, [size.height, size.width])

    return (
        <MaterialWarmup
            materials={materials}
            prepareMaterial={prepareMaterial}
        />
    )
}
